function calculateRemainingTime() {
  let currentTime = new Date().getTime();
  
  const remainingElements = document.querySelectorAll(".remaining-time");
  const order_cut_off_time = document.getElementById("order_cut_off_time");
  const cutoffTime = parseInt(order_cut_off_time.innerHTML, 10);

  remainingElements.forEach(function (remaining) {
    const targetTime = new Date();
    targetTime.setHours(cutoffTime, 0, 0, 0);

    if (new Date().getHours() >= cutoffTime) {
      targetTime.setDate(targetTime.getDate() + 1);
    }

    const remainingTime = targetTime.getTime() - currentTime;

    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor(
      (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
    );

    const hoursText = hours > 1 ? "hrs" : "hr";
    const minutesText = minutes > 1 ? "mins" : "min";

    remaining.innerHTML = `${hours} ${hoursText} ${minutes} ${minutesText}.`;
  });
}

var cartDrawerElement = document.querySelector(".drawer");
var cartObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (
      mutation.attributeName === "class" &&
      mutation.target.classList.contains("active")
    ) {
      calculateRemainingTime();
    }
  });
});
if (cartDrawerElement) {
  cartObserver.observe(cartDrawerElement, { attributes: true });
}

document.addEventListener("DOMContentLoaded", function () {
  calculateRemainingTime();
});
